var map = {
	"./image1.svg": 8519,
	"./image10.svg": 1638,
	"./image2.svg": 5568,
	"./image3.svg": 2904,
	"./image4.svg": 1778,
	"./image5.svg": 4285,
	"./image6.svg": 6814,
	"./image7.svg": 434,
	"./image8.svg": 7746,
	"./image9.svg": 3122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4441;